<template>
  <v-autocomplete v-model="selectionValue" :items="topSearchResponse" item-value="Id" item-text="Name"
    :filter="(i) => i.Id != excludedId" :search-input.sync="searchValue" :loading="loading || awaitingSearch"
    :autofocus="autofocus" :rules="rule" prepend-icon="$customer" class="customerinput" ref="customerinput"
    hide-details="auto" :dense="dense" @update:search-input="searchInput" @blur="stopTimer"
    @keypress.enter="selectItem(selectionValue)"
    @change="(val) => selectItem(val)"
    :label="dense ? undefined : ($t('servicesystem.common_objects.customer.customer') + (noempty ? '*' : ''))"
    :placeholder="$t('servicesystem.common_objects.customer.search_field_label')" persistent-placeholder
    @keypress.tab="(arg) => arg.target.blur()">
    <template v-slot:no-data>
      <p class="ma-0 px-3 py-2" style="background-color: #f2f2f2;">{{ noDataText }}</p>
    </template>
    <!--
    <template v-slot:item="{item, attrs, on}">
      <customer-li v-if="item.IsActive"
                   v-on="on"
                   v-bind="attrs"
                   :customer="item"
                   :preselected="null"
                   class="px-0">
      </customer-li>
    </template>
    -->
    <!--
    <template v-slot:item="{item, attrs, on}">
      <v-list-item v-on="on"
                   v-bind="attrs"
                   dense>
        <v-list-item-content>
          <v-list-item-title>{{item.Name}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    -->
  </v-autocomplete>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import rules from "@/helpers/Mixins/RuleMixin.js";
//import CustomerLi from "@/components/ListItems/CustomerListItem.vue";

export default {
  name: "CustomerSelect",
  props: [
    "value",
    "label",
    "dense",
    "outlined",
    "solo",
    "flat",
    "hideDetails",
    "light",
    "rounded",
    "loading",
    "disabled",
    "autofocus",
    "excludedId",
    "noempty",
  ],
  components: {
    //CustomerLi,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
      searchValue: "",
      selectionValue: null,
      searchTimeout: null,
      topSearchResponse: [],
      awaitingSearch: false,
      empty_image: "",
      IsMounted: false,
    };
  },

  mounted() {
    if (this.value) {
      this.topSearchResponse = this.value && this.value.Id ? [this.value] : [];
      this.selectionValue = this.value && this.value.Id ? this.value : null;
    }
    this.IsMounted = true;

  },

  methods: {
    stopTimer() {
      clearTimeout(this.searchTimeout);
      this.awaitingSearch = false;
    },

    async searchInput(val2) {

      if (val2 && val2 != this.value?.Name) {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }

        const val = val2;
        if (val && val != "") {
          if (val.length <= 2) {
            this.topSearchResponse = []
            this.awaitingSearch = false;
            return;
          }
          this.awaitingSearch = true;
          this.searchTimeout = setTimeout(async () => {
            if (val.length <= 2) return;
            await this.searchItemContext(val);
            this.searchTimeout = null;
            this.awaitingSearch = false;
          }, 700); // 0.7 sec delay
        } else {
          this.topSearchResponse = [];
        }
      }
    },

    clearTopSearch() {
      this.searchValue = "";
    },

    async searchItemContext(searchParameter) {

      this.topSearchResponse = [];
      await this.searchCustomersByString(searchParameter).then((response) => {
        this.topSearchResponse = response;
      });
    },

    selectItem(item) {
      //console.log(item);
      this.$emit("click", item);
      this.$emit("input", item);
      this.$refs.customerinput.blur();
    },

    focus() {
      this.$refs.customerinput.focus();
    },
  },

  computed: {
    rule() {
      if (this.noempty) {
        return this.noEmptyRule;
      } else {
        return [];
      }
    },

    noDataText() {

      if (!this.searchValue || this.searchValue.length < 3) {
        return this.$t('servicesystem.common_objects.commonterms.type_three_chars_to search')
      }
      else if (this.awaitingSearch) {
        return this.$t('servicesystem.common_objects.commonterms.searching')
      }
      else {
        return this.$t('servicesystem.common_objects.commonterms.no_results')
      }
    }
  },

  watch: {
    selectionValue(newval, oldval) {
      if (this.IsMounted && this.value != newval && oldval != newval) {

        if (this.noempty && !newval) {
          //console.log('cant emit no customer when noempty prop is true');
        }
        else {
          this.$emit("click", newval);
        }
        this.$refs.customerinput.blur();
      }
    },
  },
};
</script>


<style lang="scss">
.customerinput:not(:hover) .v-input__control .v-input__slot::before {
  border-style: none !important;
}
</style>